<template>
  <div class="signin">
    <h1>Sign In</h1>
    <div style="display: inline-block;">
      <div id="google-signin-button"></div>
    </div>
    <div style="margin-top: 25px;">
      <a href="#" @click="onSignOut">Sign Out</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'signin',
  mounted() {
    // TODO: Sometimes the Google script isn't loaded yet... handle that
    window.gapi.signin2.render('google-signin-button', {
      width: 240,
      height: 50,
      longtitle: true,
      onsuccess: this.onSignIn
    });
  },
  computed: {
    ...mapState({ apiHost: 'apiHost', bearerToken: 'bearerToken' }),
  },
  methods: {
    ...mapMutations({ setBearerToken: 'setBearerToken' }),
    ...mapMutations('user', { setUser: 'setUser' }),
    onSignIn(googleUser) {
      axios.post(
        `${this.apiHost}/user/signin`,
        { googleIdToken: googleUser.getAuthResponse().id_token }
      ).then((result) => {
        this.setBearerToken(result.data.bearerToken);
        this.setUser(result.data.profile);
        console.log(`Logged in, bearerToken: ${result.data.bearerToken}`);
        console.log(`User '${result.data.profile.fullName}' with email '${result.data.profile.email}'`);
        // TODO: Redir to requested page or profile page
      }, (error) => {
        // TODO: error handling of some sort
        console.error(error);
        this.onSignOut();
      });
    },
    onSignOut() {
      this.setBearerToken('');
      const auth2 = window.gapi.auth2.getAuthInstance();
      auth2.signOut().then(() => {
        console.log('User signed out.');
      });
    },
  },
};
</script>
